import { useQuery } from "@tanstack/react-query";
import { getAllPrograms } from "../../services/programs";

const useGetProgram = (id: number) => {
    return useQuery({
        queryKey: ["programs", id],
        queryFn: () => getAllPrograms(id),
        staleTime: Infinity,
    });
}

export default useGetProgram;